import { configureStore } from "@reduxjs/toolkit";
import generalReducer from "./app/general";
import stationsReducer from "./orm/stations";
import vehiclesReducer from "./orm/vehicles";
import userSessionReducer from "./orm/userSession";

export const store = configureStore({
  reducer: {
    general: generalReducer,
    stations: stationsReducer,
    vehicles: vehiclesReducer,
    userSession: userSessionReducer,
  },
});

store.subscribe(() => {
  try {
    const state = store.getState().userSession;
    sessionStorage.setItem("ORM_userSession", JSON.stringify(state));
  } catch (error) {
    console.error("Error saving session to storage:", error);
  }
});

// Infer the `RootState` and `AppDispatch` types from the store itself
export type RootState = ReturnType<typeof store.getState>;
// Inferred type: {posts: PostsState, comments: CommentsState, users: UsersState}
export type AppDispatch = typeof store.dispatch;
